import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent. We'll get back to you soon.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Could not send message.");
    } finally { setBusy(false); }
  };
  return (
    <div style={{ maxWidth: 560, margin: "30px auto", padding: "0 24px" }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 6 }}>CONTACT US</div>
        <h1 className="serif" style={{ fontSize: 38, color: "#fff", margin: 0, fontWeight: 400 }}>We&apos;re here to help</h1>
        <p className="muted" style={{ marginTop: 8 }}>
          Or write directly to <a href="mailto:customerservice@obituaryrelief.com" className="link-gold">customerservice@obituaryrelief.com</a>
        </p>
      </div>
      <form onSubmit={submit} className="bg-card" style={{ padding: 28 }}>
        <label className="label-dark">Name</label>
        <input data-testid="contact-name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="input-dark" style={{ marginBottom: 16 }} />
        <label className="label-dark">Email</label>
        <input data-testid="contact-email" required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="input-dark" style={{ marginBottom: 16 }} />
        <label className="label-dark">Message</label>
        <textarea data-testid="contact-message" required rows={6} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} className="input-dark" style={{ marginBottom: 18, resize: "vertical" }} />
        <button data-testid="contact-submit" type="submit" disabled={busy} className="btn-gold" style={{ width: "100%", padding: "14px" }}>{busy ? "Sending…" : "Send Message"}</button>
      </form>
    </div>
  );
}
